import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --color-bg: #f2f2f3;
    --color-surface: #e9e9ea;
    --color-text: #1d1f20;
    --color-accent: #5980a6;
    --color-accent-2: #728fab;
    --color-divider: color-mix(in srgb, #1d1f20 16%, transparent);

    --color-neutral-100: #f5f5f8;
    --color-neutral-200: #e7e7ea;
    --color-neutral-300: #d4d4d7;
    --color-neutral-400: #b7b7ba;
    --color-neutral-500: #98989b;
    --color-neutral-600: #7a7a7d;
    --color-neutral-700: #5d5d60;
    --color-neutral-800: #424244;
    --color-neutral-900: #2b2b2d;

    --color-accent-100: #eef6ff;
    --color-accent-200: #d6ebff;
    --color-accent-300: #b5d9fd;
    --color-accent-400: #94bce3;
    --color-accent-500: #749dc4;
    --color-accent-600: #597ea3;
    --color-accent-700: #416180;
    --color-accent-800: #2c455d;
    --color-accent-900: #1d2d3d;

    --font-heading: "Barlow Condensed", "IBM Plex Sans KR", system-ui, sans-serif;
    --font-body: "Barlow", "IBM Plex Sans KR", system-ui, sans-serif;
    --font-mono: ui-monospace, "SFMono-Regular", Menlo, monospace;
    --font-heading-weight: 600;
  }

  *, *::before, *::after { box-sizing: border-box; }

  html, body, #root {
    min-height: 100%;
  }

  body {
    margin: 0;
    background: var(--color-bg);
    color: var(--color-text);
    font-family: var(--font-body);
    font-size: 15px;
    line-height: 1.55;
    font-weight: 400;
    word-break: keep-all;
    overflow-wrap: break-word;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
    font-weight: var(--font-heading-weight);
    line-height: 1.12;
    margin: 0;
  }

  a { color: var(--color-accent-700); text-decoration: none; }
  a:hover { color: var(--color-accent-900); }
  pre { margin: 0; }
  button, input, select, textarea { font: inherit; }
  button, select { touch-action: manipulation; }

  :focus { outline: none; }
  :focus-visible { outline: 2px solid var(--color-accent); outline-offset: 2px; }
  ::selection { background: color-mix(in srgb, var(--color-accent) 30%, transparent); }

  @keyframes riseIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: none; }
  }

  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

export default GlobalStyle;
